module.exports = __webpack_public_path__ + "img/angle.daaf5f1b.png";